/**
 * @link https://mui.com/material-ui/react-floating-action-button/
 */

import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from "@mui/icons-material/Delete";
import RemoveDone from "@mui/icons-material/RemoveDone";
import EditIcon from '@mui/icons-material/Edit';
import NavigationIcon from '@mui/icons-material/Navigation';
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeFab() {
  return (
    <Box sx={{ '& > :not(style)': { m: 1 } }}>
      <Fab color="primary" aria-label="add">
        <AddIcon />
      </Fab>
      <Fab color="primary" variant="outlined" aria-label="edit">
        <EditIcon />
      </Fab>
      <Fab color="secondary" aria-label="remove">
        <DeleteIcon />
      </Fab>
      <Fab color="secondary" variant="outlined" aria-label="remove done">
        <RemoveDone />
      </Fab>
      <Fab color="primary" aria-label="add" disabled>
        <AddIcon />
      </Fab>
      <Fab color="primary" variant="outlined" aria-label="edit" disabled>
        <EditIcon />
      </Fab>
      <Fab color="primary" variant="extended">
        <NavigationIcon sx={{ mr: 1 }} />
        Navigate
      </Fab>
      <Fab color="secondary" variant="extended">
        <NavigationIcon sx={{ mr: 1 }} />
        Navigate
      </Fab>

      {/*SALES*/}
      <Fab color="secondary" variant="taskSales">
        Bestellung erfassen
      </Fab>
      <Fab color="secondary" variant="taskSalesActive">
        Bestellung erfassen
      </Fab>
      <Fab color="secondary" variant="taskSalesActive" disabled>
        Bestellung erfassen
      </Fab>

      {/*PURCHASE*/}
      <Fab color="secondary" variant="taskPurchase">
        Preise ermitteln
      </Fab>
      <Fab color="secondary" variant="taskPurchaseActive">
        Preise ermitteln
      </Fab>
      <Fab color="secondary" variant="taskPurchaseActive" disabled>
        Preise ermitteln
      </Fab>

      {/*ACCOUNTING*/}
      <Fab color="secondary" variant="taskAccounting">
        Rechnung erstellen
      </Fab>
      <Fab color="secondary" variant="taskAccountingActive">
        Rechnung erstellen
      </Fab>
      <Fab color="secondary" variant="taskAccountingActive" disabled>
        Rechnung erstellen
      </Fab>

      {/*ACCOUNTING*/}
      <Fab color="secondary" variant="taskAccounting">
        Rechnung erstellen
      </Fab>
      <Fab color="secondary" variant="taskAccountingActive">
        Rechnung erstellen
      </Fab>
      <Fab color="secondary" variant="taskAccountingActive" disabled>
        Rechnung erstellen
      </Fab>

      {/*QM*/}
      <Fab color="secondary" variant="taskQm">
        Rechnung erstellen
      </Fab>
      <Fab color="secondary" variant="taskQmActive">
        Rechnung erstellen
      </Fab>
      <Fab color="secondary" variant="taskQmActive" disabled>
        Rechnung erstellen
      </Fab>

      {/*Packaging*/}
      <Fab color="secondary" variant="taskPackaging">
        Verpacken
      </Fab>
      <Fab color="secondary" variant="taskPackagingActive">
        Verpacken
      </Fab>
      <Fab color="secondary" variant="taskPackagingActive" disabled>
        Verpacken
      </Fab>

      {/*Logistics*/}
      <Fab color="secondary" variant="taskLogistics">
        Senden
      </Fab>
      <Fab color="secondary" variant="taskLogisticsActive">
        Senden
      </Fab>
      <Fab color="secondary" variant="taskLogisticsActive" disabled>
        Senden
      </Fab>

      <br/>
      <br/>
      
      <ShowCode 
        codeString={`<>
  {/* Basic FABs */}
  <Box sx={{ '& > :not(style)': { m: 1 } }}>
    <Fab color="primary" aria-label="add">
      <AddIcon />
    </Fab>
    <Fab color="secondary" aria-label="edit">
      <EditIcon />
    </Fab>
    <Fab disabled aria-label="disabled">
      <AddIcon />
    </Fab>
    
    {/* Outlined variant */}
    <Fab color="primary" variant="outlined" aria-label="edit">
      <EditIcon />
    </Fab>
    
    {/* Extended FABs */}
    <Fab variant="extended" color="primary">
      <NavigationIcon sx={{ mr: 1 }} />
      Navigate
    </Fab>
    
    {/* Custom variants */}
    <Fab color="secondary" variant="taskSales">
      Sales Action
    </Fab>
    <Fab color="secondary" variant="taskPurchase">
      Purchase Action
    </Fab>
  </Box>
</>`} 
        scope={{ React, Box, Fab, AddIcon, EditIcon, NavigationIcon }} 
      />
    </Box>
  );
}
